export default "__VITE_ASSET__wKco_nFJ__"